import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noIndex />
      <div className="container-fluid section-my text-center py-20">
        <h1 className="text-6xl mb-4">404</h1>
        <p className="text-lg text-color-secondary mb-8">The page you were looking for does not exist.</p>
        <Link to="/" className="sf__btn sf__btn-primary">Back to home</Link>
      </div>
    </>
  );
}
